import React from "react";
import FormattedDate from "./formattedDate";

import WeatherTemperature from "./weatherTemperature";
import WeatherIcon from "./weatherIcon";

export default function WeatherInfo(props) {
  return (
    <div className="weatherInfo mb-3">
      <div className="row">
        <div className="col-8">
          <h1 className="city">{props.data.city}</h1>
          <span>
            Last update: <FormattedDate date={props.data.date} />
          </span>
          <ul>
            <li className="text-capitalize">{props.data.description}</li>
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind: {props.data.wind} km/h</li>
          </ul>
        </div>
        <div className="col-4">
          <WeatherIcon icon_url={props.data.icon} size="100" />
          <WeatherTemperature celsius={props.data.temperature} />
        </div>
      </div>
    </div>
  );
}
